import { ConveyancingPrice } from '@funnels/types';

import { STATE } from './asset';

export const CONVEYANCING_PRICE_DATA: ConveyancingPrice[] = [
  {
    state: STATE.ACT,
    professionalFee: 1700,
    lowSearchCost: 350,
    highSearchCost: 750,
    lowTotalCost: 2050,
    highTotalCost: 2450,
  },
  {
    state: STATE.NSW,
    professionalFee: 1700,
    lowSearchCost: 350,
    highSearchCost: 750,
    lowTotalCost: 2050,
    highTotalCost: 2450,
  },
  {
    state: STATE.NT,
    professionalFee: 1100,
    lowSearchCost: 500,
    highSearchCost: 700,
    lowTotalCost: 1600,
    highTotalCost: 1800,
  },
  {
    state: STATE.QLD,
    professionalFee: 1300,
    lowSearchCost: 850,
    highSearchCost: 1600,
    lowTotalCost: 2150,
    highTotalCost: 2900,
  },
  {
    state: STATE.SA,
    professionalFee: 1300,
    lowSearchCost: 500,
    highSearchCost: 700,
    lowTotalCost: 1800,
    highTotalCost: 2000,
  },
  {
    state: STATE.TAS,
    professionalFee: 1200,
    lowSearchCost: 450,
    highSearchCost: 750,
    lowTotalCost: 1650,
    highTotalCost: 1950,
  },
  {
    state: STATE.VIC,
    professionalFee: 1700,
    lowSearchCost: 450,
    highSearchCost: 750,
    lowTotalCost: 2150,
    highTotalCost: 2450,
  },
  {
    state: STATE.WA,
    professionalFee: 1100,
    lowSearchCost: 400,
    highSearchCost: 650,
    lowTotalCost: 1500,
    highTotalCost: 1750,
  },
];

export const STATE_WITH_CONVEYACING = [
  STATE.VIC,
  STATE.TAS,
  STATE.NSW,
  STATE.QLD,
  STATE.WA,
  STATE.ACT,
  STATE.SA,
  STATE.NT,
];
export const CONVEYACING_PRODUCT_TYPE = 'CONVEYANCING';
export const CONVEYACING_SOURCE_TYPE = 'HOME_LOAN_APPLICATION';
export const CONVEYACING_LINKED_ENTITY_TYPE = 'PROPERTY';
export const CONVEYACING_STATUS_COMPLETED = 'SUBMISSION_COMPLETED';
export const CONVEYACING_STATUS_DRAFT = 'DRAFT';
